import React, { useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import loaderImg from "../../icons/photos/loaderImg.gif";
import loaderImgGIF from '../../media/images/loaderImgGIF.gif'
import { backLoaderFalse, backLoaderTrue, updateServiceReqModalTrue } from '../../feature/userData/userData'
import './backdrop.scss'
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connectToPro } from '../../service/api/ticket/connectToPro';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import updateTicketStatus from '../../service/api/ticket/updateTicketStatus';
import { triggerNotificationToProApi } from '../../service/api/ticket/triggerNotificationToPro';
import { useNavigate } from 'react-router-dom';
import deleteTicketByIdApi from '../../service/api/ticket/deleteTicketById';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import { RiCameraLensLine, RiHome3Line } from 'react-icons/ri';
import { MdMicNone, MdOutlineVideocam } from 'react-icons/md';
import { isWifiConnection } from './isWifiConnection';

const BackDrop = ({ showUpdate, openLoader, categoryObj }) => {
    const dispatch = useDispatch();
    const { loaderTime } = useSelector((state) => state.user);
    const navigate = useNavigate();

    const [open, setOpen] = useState(true);

    const [message, setMessage] = useState(`Please be patient while we search for ${categoryObj?.category_display_name_chr ? categoryObj?.category_display_name_chr : ''} professional to assist you.`);
    const [serviceState, setServiceState] = useState(false);
    const [isCancelServiceReq, setIsCancelServiceReq] = useState(false);
    const [deleteServiceReqLoading, setDeleteServiceReqLoading] = useState(false);
    const [loadingForCancelRequest, setLoadingForCancelRequest] = useState(false);

    const [responseMsg, setResponseMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);

    const wifiStatus = isWifiConnection();

    const handleClose = () => {
        setOpen(false);
        dispatch(backLoaderFalse());

    };
    const handleOpen = () => {
        setOpen(true);
    };

    const triggerNotificationToProAfterSearchEnds = () => {
        // dispatch(backLoaderTrue());
        let data = {
            ticket_id_ids: localStorage.getItem("ticket_id"),
        }
        dispatch(triggerNotificationToProApi(data, (res) => {

        }, (err) => {

        }))
    }

    const connectToProfessional = () => {
        // dispatch(backLoaderTrue());
        if (isCancelServiceReq) return;

        let data = {
            ticket_id_ids: localStorage.getItem("ticket_id"),
            re_initiate_flag: 0,
        }
        dispatch(connectToPro(data, (res) => {
            if (!res.data.search_pro) {
                dispatch(backLoaderFalse())

                if (process.env.REACT_APP_GUEST_USER_ID_IDS !== localStorage.getItem("user_id")) {
                    triggerNotificationToProAfterSearchEnds();
                }
                if (showUpdate) {
                    // dispatch(updateServiceReqModalTrue());
                }

            }
        }, (err) => {

            dispatch(backLoaderFalse())

            if (showUpdate) {
                // dispatch(updateServiceReqModalTrue());
            }
        }))
    }


    useEffect(() => {
        const id = setInterval(() => {
            if (!isCancelServiceReq) {
                connectToProfessional();
            }
        }, loaderTime)

        return () => {
            clearInterval(id);
            dispatch(backLoaderFalse());
        }
    }, [])


    useEffect(() => {
        const id1 = setTimeout(() => {
            setMessage("Be patient! We are still looking for the best professional.");
        }, 40000);

        return () => {
            clearTimeout(id1);
            dispatch(backLoaderFalse());
        }
    }, [])

    const cancelRequest = () => {
        setLoadingForCancelRequest(true);
        let formData = new FormData();

        formData.append("ticket_id_ids", localStorage.getItem("ticket_id"));
        formData.append("ticket_status_ysn", 7);

        dispatch(updateTicketStatus(formData, (res) => {

            setLoadingForCancelRequest(false);
            dispatch(backLoaderFalse());
            navigate('/serviceRequestDetails');
        }), (res) => {
            setLoadingForCancelRequest(false);

            setResponseMsg(res.data.message)
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        })
    }

    const deleteServiceReqFunc = () => {
        setDeleteServiceReqLoading(true);

        let details = {
            ticket_id_ids: localStorage.getItem("ticket_id"),
        };

        dispatch(deleteTicketByIdApi(details, (res) => {

            setDeleteServiceReqLoading(false);
            dispatch(backLoaderFalse());
            navigate('/');
        }), (res) => {
            setDeleteServiceReqLoading(false);

            setResponseMsg(res.data.message)
            setToasterType("error")

            setHandleToaster(true);
            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        })
    }


    return (
        <div className={`backdrop ${openLoader ? 'open' : ''}`}>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '100vw', height: '100dvh' }}>

                {!isCancelServiceReq ? <>
                    <div
                        className='row mx-0 d-flex flex-column'
                        style={{ minHeight: 'calc(100dvh - 0px)' }}
                    >
                        <div className='row mx-0 '>
                            {window.innerWidth > 768 && <div className='col-md-3'></div>}
                            <div
                                className={`col-md-6 d-flex position-relative px-3 py-1`}
                            >
                                <div className='row mx-0'>
                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center my-3'>
                                        <span className='fs-4 font-w600 text-center text-black'>{`Searching for a Pro`}</span>
                                    </div>

                                    <div className='col-12 px-0'>
                                        <img
                                            // className='loader-gif'
                                            style={{ width: '100%' }}
                                            src={loaderImgGIF}
                                            alt='Searching for a Pro'
                                        />
                                    </div>

                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center mt-2'>
                                        <span className='fs-5 font-w600 text-center '>
                                            {message}
                                        </span>
                                    </div>

                                    <div className='col-12 d-flex flex-column mt-2 p-3 bg-white rounded-2'>
                                        <div className='w-100'>
                                            <span className='fs-4 font-w600  text-black'>
                                                {`Prepare for your Chilll request`}
                                            </span>
                                        </div>



                                        <div className='w-100 mt-2 d-flex align-items-baseline'>
                                            <span className='me-3' style={{ color: '', fontSize: '20px' }}>
                                                <RiCameraLensLine />
                                            </span>
                                            <span className='fs-4 font-w500'>
                                                {`Clean your camera lens`}
                                            </span>
                                        </div>

                                        <div className='w-100 mt-2 d-flex align-items-baseline'>
                                            <span className='me-3' style={{ color: '', fontSize: '20px' }}>
                                                <RiHome3Line />
                                            </span>
                                            <span className='fs-4 font-w500 '>
                                                {`Organize the area for easy access`}
                                            </span>
                                        </div>

                                        <div className='w-100 my-2' style={{ height: '1px', background: '#0000007d' }}></div>

                                        <div className='w-100 mt-2 d-flex align-items-baseline'>
                                            <span className='me-3' style={{ color: wifiStatus ? '#21d262' : '#ff0000', fontSize: '20px' }}>
                                                <i class="bi bi-wifi"></i>
                                            </span>
                                            <span className='fs-4 font-w600'>
                                                {`${wifiStatus ? 'Connected' : 'Connect'} to wi-fi`}
                                            </span>
                                        </div>

                                        <div className='w-100 d-flex align-items-baseline'>
                                            <span className='me-3' style={{ color: '#21d262', fontSize: '20px' }}>
                                                <MdMicNone />
                                            </span>
                                            <span className='fs-4 font-w600 ' style={{ color: '#879ebf' }}>
                                                {`Microphone access allowed`}
                                            </span>
                                        </div>

                                        <div className='w-100 mt-2 d-flex align-items-baseline'>
                                            <span className='me-3' style={{ color: '#21d262', fontSize: '20px' }}>
                                                <MdOutlineVideocam />
                                            </span>
                                            <span className='fs-4 font-w600' style={{ color: '#879ebf' }}>
                                                {`Camera access allowed`}
                                            </span>
                                        </div>
                                    </div>

                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center mt-3'>
                                        <PrimaryButton
                                            onClick={() => {
                                                setIsCancelServiceReq(true);
                                                // cancelRequest()
                                            }}
                                            buttonName={"CANCEL REQUEST"}
                                            loadingMessage={"Canceling..."}
                                            isLoading={false}
                                            style={{
                                                width: '210px',
                                                background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                border: '2px solid rgba(240, 72, 72, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    {/* <>
                        <img className='loader-gif' src={loaderImgGIF} alt='Error Loading' />

                        <p className="text-center" style={{ color: 'black', fontSize: '20px', margin: '25px' }}>
                            {message}
                        </p>

                        <PrimaryButton
                            onClick={() => {
                                setIsCancelServiceReq(true);
                                // cancelRequest()
                            }}
                            buttonName={"CANCEL REQUEST"}
                            loadingMessage={"Canceling..."}
                            isLoading={false}
                            style={{
                                width: '210px',
                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                border: '2px solid rgba(255, 154, 32, 1)',
                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                            }}
                        />
                    </> */}
                </> :
                    <>
                        <div className='row'>
                            <div className='col-12 d-flex'>
                                <span
                                    onClick={() => { setIsCancelServiceReq(false) }}
                                    className='fs-4 fw-bold text-black px-2 cursor-pointer'
                                >
                                    <i class="bi bi-x-lg"></i>
                                </span>
                            </div>
                            <div className='col-12 d-flex justify-content-center'>
                                <span className='fs-1 fw-bold text-black text-center px-2'>{`Cancel Service request`}</span>
                            </div>

                            <div className='col-12 d-flex justify-content-center mt-3'>
                                <span className='fs-4 text-black text-center px-2'>{`Are you sure you want to delete or save changes to this service request?`}</span>
                            </div>

                            <div className='col-12 d-flex justify-content-center mt-4'>
                                <div
                                    className='row mx-0'
                                    style={{
                                        opacity: deleteServiceReqLoading || loadingForCancelRequest ? '0.6' : '1',
                                        pointerEvents: deleteServiceReqLoading || loadingForCancelRequest ? 'none' : 'auto',
                                    }}
                                >
                                    <div className='col-12 col-sm-6 d-flex justify-content-center mb-3 pe-sm-2'>
                                        <PrimaryButton
                                            onClick={() => { deleteServiceReqFunc() }}
                                            buttonName={"DELETE REQUEST"}
                                            loadingMessage={"DELETING..."}
                                            isLoading={deleteServiceReqLoading}
                                            style={{
                                                width: '210px',
                                                background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                border: '2px solid rgba(240, 72, 72, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>

                                    <div className='col-12 col-sm-6 d-flex justify-content-center mb-3 ps-sm-2'>
                                        <PrimaryButton
                                            onClick={() => { cancelRequest() }}
                                            buttonName={"SAVE REQUEST"}
                                            loadingMessage={"SAVING..."}
                                            isLoading={loadingForCancelRequest}
                                            style={{
                                                width: '210px',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>}
            </div>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responseMsg} />}

        </div>
    )
}

export default BackDrop;